import { TrixToolbarA11y } from './trix_toolbar_a11y';

function setup(trixField) {
  const toolbar = trixField.editor?.element?.toolbarElement;
  if (!toolbar) return;
  new TrixToolbarA11y(toolbar, trixField).init();
}

// Admin-trix dispatches promote:trix-initialize after AdvancedEditorTemplate
// rewrites the toolbar HTML. Non-bubbling, so listen with capture=true on document.
document.addEventListener(
  'promote:trix-initialize',
  (event) => setup(event.target), true
);

// Default (non-admin) trix fires trix-initialize once Trix renders the toolbar.
// Skip admin-trix here to avoid double-init (handled by the listener above).
document.addEventListener('trix-initialize', (event) => {
  if (event.target.dataset.adminTrix) return;
  setup(event.target);
});
